import Actions from '../../odata/actions';

const actions = new Actions('orgTarget', 'orgTargets');

export default actions;
